<template>
  <header class="sticky top-0 z-50 bg-base-100">
    <div class="navbar px-4 flex items-center">
      <div class="flex-1 flex items-center">
        <h1 class="text-xl font-bold">Kelionės</h1>
        <span
          v-if="appEnvironment === 'dev'"
          class="badge badge-warning ml-2 text-xs"
        >
          Testavimo aplinka
        </span>
      </div>
      <!-- Optional: Add a button for additional actions -->
      <div class="flex-none">
        <button class="btn btn-ghost btn-circle">
          <DefaultIcon name="info" size="w-6 h-6" />
        </button>
      </div>
    </div>
  </header>

  <!-- Tabs -->
  <div class="px-4">
    <div class="flex space-x-4">
      <button
        @click="setActiveTab('upcoming')"
        class="pb-2 px-1"
        :class="[
          activeTab === 'upcoming'
            ? 'border-b-2 border-primary text-primary font-medium'
            : 'text-base-content/60',
        ]"
      >
        Planuojamos
      </button>
      <button
        @click="setActiveTab('past')"
        class="pb-2 px-1"
        :class="[
          activeTab === 'past'
            ? 'border-b-2 border-primary text-primary font-medium'
            : 'text-base-content/60',
        ]"
      >
        Įvykusios
      </button>
    </div>
  </div>

  <div v-if="!travelStore.isLoading">
    <!-- Content -->
    <div v-if="activeTab === 'upcoming'">
      <div class="">
        <h1 class="text-lg font-semibold mt-6 mb-3 px-4">Kelionės šiandien</h1>
        <div v-if="todayTravels.length" class="bg-success/20 px-4">
          <div v-for="todayTravel in todayTravels" :key="todayTravel.id">
            <div v-if="todayTravel.date_status === 'today'">
              <router-link
                :to="`/driving/travels/${todayTravel.id}`"
                class="block py-3"
              >
                <TravelInfo :travel="todayTravel" />
              </router-link>
            </div>
          </div>
        </div>
        <div v-else class="p-4 text-center text-base-content/70">
          Šiandien kelionių nesuplanuota
        </div>
      </div>
      <div class="px-4 pt-6">
        <h1 class="text-lg font-semibold my-3">Planuojamos kelionės</h1>
        <div v-if="upcomingTravels.length">
          <router-link
            v-for="upcomingTravel in upcomingTravels"
            :key="upcomingTravel.id"
            :to="`/driving/travels/${upcomingTravel.id}`"
            class="block py-3"
          >
            <div v-if="upcomingTravel.date_status === 'upcoming'">
              <TravelInfo :travel="upcomingTravel" />
            </div>
          </router-link>
        </div>
        <div v-else class="p-4 text-center text-base-content/70">
          Nėra planuojamų kelionių
        </div>
      </div>
    </div>

    <div v-else>
      <div class="px-4 mt-3" v-if="travels.length">
        <router-link
          v-for="pastTravel in travels"
          :key="pastTravel.id"
          :to="`/driving/travels/${pastTravel.id}`"
          class="block py-3"
        >
          <TravelInfo :travel="pastTravel" />
        </router-link>
      </div>
      <div v-else class="p-4 text-center text-base-content/70">
        Nėra įvykusių kelionių
      </div>
    </div>
  </div>
  <div v-else class="text-center py-8">
    <span class="loading loading-spinner loading-xl"></span>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useTravelStore } from "@/stores/travels";
import TravelInfo from "../../../components/driving/travels/TravelInfo.vue";
import { useTimeManagement } from "@/composables/time/useTimeManagement";
import DefaultIcon from "@/components/icons/DefaultIcon.vue";

const travelStore = useTravelStore();
const { getTodayDate } = useTimeManagement();
const activeTab = ref("upcoming");

const travels = ref({});

onMounted(async () => {
  try {
    fetchTravels("upcoming");
  } catch (error) {
    console.error("Failed to fetch travels:", error);
  }
});

const appEnvironment = computed(() => {
  return process.env.VUE_APP_MODE;
});

const fetchTravels = async (type) => {
  if (type === "upcoming") {
    travels.value = await travelStore.fetchTravels({
      status: "travelStatus1,travelStatus2",
      date_from: getTodayDate(),
    });
  } else if (type === "past") {
    travels.value = await travelStore.fetchTravels({
      status: "travelStatus3",
    });
  } else {
    travels.value = await travelStore.fetchTravels();
  }
};

const todayTravels = computed(() => {
  return Array.isArray(travels.value)
    ? travels.value.filter((travel) => travel.date_status === "today")
    : [];
});

const upcomingTravels = computed(() => {
  return Array.isArray(travels.value)
    ? travels.value.filter((travel) => travel.date_status === "upcoming")
    : [];
});

const setActiveTab = (type) => {
  activeTab.value = type;
  fetchTravels(type);
};
</script>
